/* import { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { Tooltip } from "@mui/material"



import { LayoutTemplate } from "lucide-react";

import '../projects.css';

import { Model } from "../../../models/model";
import { ModeGantt } from "../../tasks/ModeGantt"
import { DialogFormTask } from "../../tasks/DialogFormTask"
import { DialogTemplates } from "./templates/DialogTemplates"
import { TasksModeList } from "../../tasks/new/TasksModeList"*/

import moment from "moment-timezone"
import { useTask } from "../../../hooks/useTask"

moment().tz("America/Lima").format()

export const ProjectsTaskNewV3 = ({ id_ppto }) => {

    const {
        hitos,
        /* tasks,

        loading,
        openDialog,
        setOpenDialog,

        form,
        filters,
        handleFilters,

        openCreate,
        openEdit,

        updateForm,
        saveTask, */
    } = useTask({ id_ppto });

    console.log({ hitos })

    return (
        <div>
            <table className="table">
                <thead>
                    <tr>
                        <th>TAREA / HITO</th>
                        <th>RESPONSABLE</th>
                        <th>DÍAS</th>
                        <th>INICIO / FIN</th>
                        <th>ESTADO</th>
                    </tr>
                </thead>
                <tbody>
                    {hitos.map(item => (
                        <tr>
                            <td>Hito {item.orden}: {item?.nombre || ''}</td>
                            <td>{item?.id_responsable || ''}</td>
                            <td>{item.dias}</td>
                            <td>{item.fecha_inicio} / {item.fecha_fin}</td>
                            <td>{item.estado}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )

}